import { api } from "@/lib/api";

// Fetches an authed PDF through the axios client (attaches the Bearer token)
// and opens it in a new tab. A plain <a href>/iframe would omit the token → 401.
export async function openAuthedPdf(path) {
  const response = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  window.open(url, "_blank", "noopener,noreferrer");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
